import { render, staticRenderFns } from "./ProductosHistorial.vue?vue&type=template&id=3b26002e&"
import script from "./ProductosHistorial.vue?vue&type=script&lang=js&"
export * from "./ProductosHistorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports